// SidebarItems.js
import IconHome from "../images/home.png";
import IconUser from "../images/user.png";
import IconFounisseur from "../images/IconFournisseur.png";
import IconCatalogue from "../images/catalogue.png";
import IconCommand from "../images/fi_truck.png";
import IconDelivery from "../images/fi_package.png";
import IconPromoCode from "../images/fi_percent.png";
import IconInfo from "../images/info_outline_24px.png";
import IconFacturation from "../images/fi_calendar.png";
import IconSecurity from "../images/fi_alert-circle.png";
import IconLivreur from "../images/fi_truck.png";

const SidebarItems = [
  {
    name: "Dashboard",
    route: "/dashboard",
    icon: IconHome,
  },
  {
    name: "Commandes",
    route: "#",
    icon: IconCommand,
    subcategories: [
      {
        name: "Livraison",
        route: "/commandes_Allfournisseur",
      },
      {
        name: "E-commerce",
        route: "/orders",
      }
    ],
  },
  {
    name: "KPI",
    route: "/",
    icon: IconInfo,
    subcategories: [
      {
        name: "Livraison",
        route: "/livreurs-shifts",
      },
      {
        name: "E-commerce",
        route: "/kpi",
      },
    ],
  },
  {
    name: "Facturation",
    route: "/fournisseurs",
    icon: IconFacturation,
  },
  // Séparation visuelle 1
  {
    name: "separator-1",
    separator: true,
  },
  {
    name: "Livreurs",
    route: "/",
    icon: IconLivreur,
    subcategories: [
      {
        name: "Planning",
        route: "/livreurs/planning",
      },
      {
        name: "Zones",
        route: "/livreurs/zones",
      },
    ],
  },
  {
    name: "Utilisateurs",
    route: "/users",
    icon: IconUser
  },
  {
    name: "Codes promo",
    route: "/CodePromo",
    icon: IconPromoCode,
  },
  {
    name: "Catalogue",
    route: "/",
    icon: IconCatalogue,
    subcategories: [
      {
        name: "Produits",
        route: "/products",
      },
      {
        name: "Marques",
        route: "/brands",
      },
      {
        name: "Catégories",
        route: "categoriesBO",
      },
    ],
  },
  {
    name: "Livraisons",
    route: "/",
    icon: IconDelivery,
    subcategories: [
      {
        name: "Centres de livraison",
        route: "/deliveries",
      },
      {
        name: "Tours de livraison",
        route: "/tour",
      },
    ],
  },
  // Séparation visuelle 2
  {
    name: "separator-2",
    separator: true,
  },
  {
    name: "RGPD/Sécurité",
    route: "/",
    icon: IconSecurity,
    subcategories: [
      {
        name: "Modifications",
        route: "/actions",
      },
      {
        name: "Consultations",
        route: "/consultations",
      },
      {
        name: "Connexions",
        route: "/login-attempts",
      },
    ],
  },
];

export default SidebarItems;
